import AvatarsContainer from "../../../Components/UiKits/Avatars/AvatarsContainer"

const Avatars = () => {
  return <AvatarsContainer/>;
};

export default Avatars;
